import React from "react";
import styled, { css } from "styled-components";
import {fontSize} from "../common/styled-mixins";

type TypeSplittedName = {
  name: string,
  specifier: ?string,
};

function splitStockName(fullName: string): TypeSplittedName {
  let name = fullName;
  let specifier = null;

  const split = fullName.indexOf("(");

  if (~split) {
    name = fullName.substring(0, split).trimEnd();
    specifier = fullName.substring(split);
  }

  return {
    name,
    specifier,
  };
}

type SplittedNameProps = {
  name: string,
  specifier: string,
  isNew: boolean
};

const Splitted = styled.div`
  line-height: normal;
  display: inline-flex;
  flex-flow: column;
  align-items: flex-start;
`;

const Details = styled.span`
  display:flex;
  flex-flow:row;
`;

const Name = styled.span`
  font-size: 12px;
`;

const Specifier = styled.span`
  font-size: 8px;
`;

const TextCont = styled.span`
  position:relative;
`;

const NewLabel = styled.div`
  position: absolute;
  top: 3px;
  text-transform: uppercase;
  font-size: ${fontSize(8)};
  z-index: 1;
  color: ${({ theme }) => theme.accent};
  
  ${(props) =>
  props.static &&
  css`
    position:static;
    left:0;
    right:0;
    padding-left:3px;
  `};
  
`;

function SplittedName(props: SplittedNameProps) {
  return (
    <Splitted>
      <Name>{props.name}</Name>
      <Details>
        <Specifier>{props.specifier}</Specifier>
        {props.isNew && <NewLabel static={true}>new</NewLabel>}
      </Details>
    </Splitted>
  );
}

type Props = {
  name: string,
  isNew: boolean
};

function StockName(props: Props) {
  // We migth get stock name as "stockname (some abbriviation)", so
  // we split it to render differently
  const { name, specifier } = splitStockName(props.name);

  return specifier ? <SplittedName isNew={props.isNew} name={name} specifier={specifier} /> :
      props.isNew ? <TextCont>{name}<NewLabel>new</NewLabel></TextCont> : name;
}

export default StockName;



// WEBPACK FOOTER //
// ./src/components/StockMenu/StockName.js